import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getAuthToken } from './shared/auth';
import * as sagaAction from './sagas/saga_action';

/* eslint-disable react/no-children-prop */
class Auth extends Component {
  componentWillMount() {
    this.userWillTransfer();
  }

  userWillTransfer() {
    const token = getAuthToken();
    if (!token) {
      this.setState({ isAuthenticated: false });
    } else {
      this.setState({ isAuthenticated: true });
      if (Object.keys(this.props.playerSettings).length === 0) {
        this.props.getPlayerSettings();
      }
    }
  }

  render() {
    return (
      this.state.isAuthenticated ? (
        <Route children={this.props.children} />
      ) : (
        <Redirect to="login" />
      )
    );
  }
}
/* eslint-enable react/no-children-prop */

Auth.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  getPlayerSettings: PropTypes.func.isRequired,
  playerSettings: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withRouter(connect(state => ({
  playerSettings: state.reducers.player.settings,
}), dispatch => ({
  getPlayerSettings: async () => {
    dispatch({
      type: sagaAction.SAGA_GET_PLAYER_SETTINGS,
    });
  },
}))(Auth));
